<template>
    <div>
        <v-dialog v-model="attendAppointmentModal" max-width="560px" content-class="add-appointment view-edit">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">
                        {{ appointment.course.title }}
                    </h4>
                    <div class="tools">
                        <v-btn icon @click="attendAppointmentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="pa-3">
                    <v-row>
                        <v-col col="6" class="d-flex">
                            <v-avatar size="30">
                                <v-icon role="img" aria-hidden="false">mdi-calendar-text-outline</v-icon>
                            </v-avatar>
                            <div class="ml-2">
                                <label>{{ $page.props.lang.date || "Date" }}</label>
                                <div><b>{{ appointment.start_date | formatDate }}</b></div>
                            </div>
                        </v-col>
                        <v-col col="6" class="d-flex">
                            <v-avatar size="30">
                                <v-icon role="img" aria-hidden="false">mdi-progress-clock</v-icon>
                            </v-avatar>
                            <div class="ml-2">
                                <label>{{ $page.props.lang.duration || "Duration" }}</label>
                                <div><b>{{ appointment.start_date | formatTime }} - {{ appointment.end_date | formatTime }} ({{ appointment.duration }} <span class="min">min)</span></b></div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="d-flex">
                            <v-avatar size="30">
                                <v-icon role="img" aria-hidden="false">mdi-account-outline</v-icon>
                            </v-avatar>
                            <div class="ml-2">
                                <label>{{ $page.props.lang.trainer || "Trainer" }}</label>
                                <div><b>{{ appointment.trainer.full_name }}</b></div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <v-divider></v-divider>
                <div class="pa-3">
                    <v-row>
                        <v-col class="d-flex">
                            <v-avatar size="30">
                                <img :src="appointment.member.profile_photo_url + '?w=30'" alt="">
                            </v-avatar>
                            <h3 class="ml-2">{{appointment.member.full_name}}</h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="ml-7" cols="8">
                            <label>{{ $page.props.lang.select_membership || "Select membership" }}</label>
                            <v-select
                                v-model="model.subscription_id"
                                :items="appointment.member.subscriptions"
                                :hint="currentSubscription != null ? currentSubscription.remaining : ''"
                                persistent-hint
                                item-text="name"
                                item-value="id"
                                :error-messages="errors.subscription_id"
                                dense outlined flat>
                                </v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="ml-7" cols="8">
                            <label>{{ $page.props.lang.select_attendance || "Select attendance" }}</label>
                            <v-select v-model="model.status"
                                hide-details
                                :items="statusItems" 
                                item-text="title" 
                                item-value="value"
                                dense outlined solo flat>
                            </v-select>
                             <v-checkbox v-model="model.charge" 
                                        v-if="model.status != 1" 
                                        dense outlined solo flat
                                        :label="($page.props.lang.still_charge_session || 'Still charge for session')" 
                                        hide-details></v-checkbox>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2" @click="makeAttendance()" :loading="saving" color="primary">{{ $page.props.lang.complete || "Complete" }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import EventBus from '@/js/eventbus'
export default {
    props: {
        open: Boolean,
        appointment: Object,
    },
    data(){
        return {
            statusItems: [
                { title: this.$page.props.lang.attended || 'Attended', value: 1},
                { title: this.$page.props.lang.canceled || 'Canceled', value: -1},
                { title: this.$page.props.lang.missing || 'Missing', value: 0}
            ],
            saving: false,
            currentSubscription: null,
            checkedBoxes: [],
            confirmCompleteModal: false,
            errors: {}, 
            model: {
                subscription_id: null,
                period_id: null,
                status: null,
                charge: false,
                appointment_id: null,
                member_id: null
            }    
        }
    },
    computed: {
        attendAppointmentModal: {
            get: function() {
                 this.model.appointment_id = this.appointment.id;
                 this.model.member_id = this.appointment.member.id;
                if(this.appointment.member.subscriptions.length > 0){
                    this.model.subscription_id = this.appointment.member.subscriptions[0].id;

                    this.currentSubscription = this.appointment.member.subscriptions[0];
                }else{
                    this.model.subscription_id = null;
                    this.currentSubscription = null;
                }

                this.model.charge = false;
                this.model.status = 1;
                
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
    watch:{
         model: {
            deep: true,
            handler: function(val, oldVal){
                this.currentSubscription = this.appointment.member.subscriptions.find(i => i.id == val.subscription_id);
                this.model.period_id = this.currentSubscription.period_id;
            }
        },
    },
    methods: {
        makeAttendance() {
            this.saving = true;
            axios.post('/backoffice/home/make_attendance', this.model)
                .then(response => {
                    var color = "error";
                    this.saving = false;
                    if(response.data.status==="OK") { 
                      
                       EventBus.$emit('CLOSE_ATTENDENSE_MODAL', response.data);
                       color = 'success';
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: color,
                        timeout: 5000
                    });
                })
                 .catch(error => {
                     this.saving = false;
                     EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 5000
                    });

                    this.errors = error.response.data.errors
                });
        }
    }
}
</script>